export const BINGO_CATEGORY_IDS = [
    "DECADE",
    "YEAR_PM2",
    "YEAR_PM4",
    "YEAR_EXACT",
    "BEFORE_2000",
    "SOLO_GROUP",
    "ARTIST",
    "TITLE",
    "GENRE",
    "COUNTRY",
    "LANGUAGE",
];
export const BINGO_GRID_SIZES = [3, 4, 5, 6, 7];
export const DEFAULT_BINGO_WIN = {
    horizontal: true,
    vertical: true,
    diagonal: true,
};
export const DEFAULT_BINGO_SETTINGS = {
    gridSize: 4,
    timerSeconds: 25,
    winConditions: { ...DEFAULT_BINGO_WIN },
    exactYearPower: true,
    categories: ["DECADE", "YEAR_PM4", "BEFORE_2000", "SOLO_GROUP"],
    preset: "easy",
};
export const BINGO_PHASE_MS = {
    CATEGORY_REVEAL: 2800,
    ANSWERS_LOCKED: 450,
    ANSWER_VOTE: 10_000,
    RESULT_REVEAL: 5200,
    CELL_SELECTION: 20_000,
    POWER_SELECTION: 30_000,
    ROUND_END: 1600,
};
